import { render, staticRenderFns } from "./TradeWatcherButton.vue?vue&type=template&id=dd28254c&scoped=true"
import script from "./TradeWatcherButton.vue?vue&type=script&lang=js"
export * from "./TradeWatcherButton.vue?vue&type=script&lang=js"
import style0 from "./TradeWatcherButton.vue?vue&type=style&index=0&id=dd28254c&lang=scss&scoped=true"
import style1 from "./TradeWatcherButton.vue?vue&type=style&index=1&id=dd28254c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd28254c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd28254c')) {
      api.createRecord('dd28254c', component.options)
    } else {
      api.reload('dd28254c', component.options)
    }
    module.hot.accept("./TradeWatcherButton.vue?vue&type=template&id=dd28254c&scoped=true", function () {
      api.rerender('dd28254c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home/TradeWatcherButton.vue"
export default component.exports